import { styled, css } from 'styled-components';

export const Content = styled.div`
  width: 100%;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.default[50]}00 0%,
    ${({ theme }) => theme.colors.base} 55%
  );
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding-top: 150px;
`;

export const Overlay = styled.div<{ $hideOverlay?: boolean }>`
  display: flex;
  width: 100%;
  padding: 48px 24px 24px 24px;
  flex-direction: column;
  justify-content: flex-end;
  gap: 4px;
  position: absolute;
  bottom: 0;

  ${({ $hideOverlay }) =>
    $hideOverlay &&
    css`
      position: relative;

      ${Content} {
        padding-top: 0;
      }
    `}
`;

export const ReviewImages = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  max-width: 100vw;
  overflow: visible;
  flex-wrap: wrap;

  > * {
    height: 90px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;

    img {
      height: 90px;
      object-fit: contain;
    }
  }
`;

export const CtaLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${(props) => props.theme.colors.primary[600]};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
`;
